import React from "react";

const DateTimeDisplay = ({ value, isDanger }) => {
  return (
    <span className={isDanger ? "countdown danger" : "countdown"}>
      <span>{value < 10 ? "0" + value : value}</span>
    </span>
  );
};

export default DateTimeDisplay;
